import styled from 'styled-components';

export const ScatterPlotContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
